// mouse-follow-tooltip.js
export default {
  namespaced: true, // 使用namespaced确保模块的state、mutations、actions和getters是命名空间化的

  state() {
    return {
      message: "选择位置",
      visible: false,
    };
  },

  mutations: {
    SET_MESSAGE(state, message) {
      state.message = message || "选择位置";
    },
    SET_VISIBLE(state, visible) {
      state.visible = visible;
    },

    // 其他mutations...
  },

  actions: {
    // 其他actions...
  },

  getters: {
    message: (state) => state.message,
    visible: (state) => state.visible,
    // 其他getters...
  },
};
